import React from "react";
import { Field } from "formik";
import styled from "styled-components";
import { FormGroup } from "components/bootstrap";
import useDataLakeTableOptions from "data-lake/preview/storage-types/external/hooks/useDataLakeTableOptions";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import { Select } from "components/common";
import StyledLabel from "data-lake/components/DataLakeActionModals/StyledLabel";
const Container = styled(FormGroup)`
  flex: 1;
  grid-area: table;
`;
const placeholder = "Select the table you want to preview logs for";
const TableFilter = () => {
  const { selectedDataLake } = useSelectedDataLake();
  const { data, isLoading } = useDataLakeTableOptions(selectedDataLake == null ? void 0 : selectedDataLake.id);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledLabel, null, "Table:"), /* @__PURE__ */ React.createElement(Field, { name: "streamIds" }, ({ field: { value, onChange, name }, meta: { error } }) => /* @__PURE__ */ React.createElement(Container, { "data-testid": "streamIds-filter", validationState: error ? "error" : void 0, bsClass: "no-bm" }, /* @__PURE__ */ React.createElement(
    Select,
    {
      placeholder,
      displayKey: "key",
      inputId: "streamIds-filter",
      value: value == null ? void 0 : value[0],
      options: data,
      multi: false,
      onChange: (newVal) => {
        onChange({ target: { value: [newVal], name } });
      },
      isLoading
    }
  ))));
};
export default TableFilter;
